// extracted by mini-css-extract-plugin
export default {"notification-settings":"NotificationSettings_notification-settings__m4VGn","notification-settings__divider":"NotificationSettings_notification-settings__divider__ttp+t"};